import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useLowQuotaBannerManagement } from "../../../hooks/useLowQuotaBannerManagement";
import { quotaKeys } from "../../../utils/i18n";

type DataCreditsNoCreditsTooltipProps = {
    isNoTouchUser: boolean;
    isAdminUser: boolean;
    remaining: number;
};

export const DataCreditsNoCreditsTooltip = ({
    isNoTouchUser,
    isAdminUser,
    remaining,
}: DataCreditsNoCreditsTooltipProps) => {
    const { translate } = useTranslate();
    const { lowCreditsBannerConfigs } = useLowQuotaBannerManagement();
    const showActionLink = lowCreditsBannerConfigs.onClick && lowCreditsBannerConfigs.buttonTextKey;

    let description: string;

    if (isNoTouchUser) {
        description = translate(quotaKeys.dataCreditsExtendedNoCreditsDescription);
    } else if (isAdminUser) {
        description = translate(quotaKeys.lowCreditsText);
    } else {
        const { key, replacements } = quotaKeys.lowCreditsLeft({ quota: remaining });
        description = translate(key, replacements);
    }

    return (
        <Stack
            width="230px"
            gap="4px"
            data-automation="quota-data-credits-tooltip-no-credits"
        >
            <Text
                fontVariant="listItem4"
                color={colorsPalettes.bluegrey[100]}
            >
                {translate(quotaKeys.dataCreditsExtendedNoCreditsTitle)}
            </Text>
            <Text
                fontVariant="tooltip"
                color={colorsPalettes.bluegrey[100]}
            >
                {description}
            </Text>
            {showActionLink ? (
                <Text
                    as="a"
                    onClick={lowCreditsBannerConfigs.onClick}
                    fontVariant="tooltip"
                    color={colorsPalettes.blue[300]}
                    cursor="pointer"
                    data-automation="quota-data-credits-tooltip-addon-link"
                >
                    {translate(lowCreditsBannerConfigs.buttonTextKey)}
                </Text>
            ) : null}
        </Stack>
    );
};
